import { render, staticRenderFns } from "./WithdrawSecList.vue?vue&type=template&id=97c15edc"
import script from "./WithdrawSecList.vue?vue&type=script&lang=js"
export * from "./WithdrawSecList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports